import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
const API_TOKEN = process.env.REACT_APP_API_TOKEN;

const useFetchStands = (exhibition, pavCode) => {
  const [stands, setStands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!exhibition || !pavCode) {
      console.warn("⚠️ Missing parameters for fetching stands:", { exhibition, pavCode });
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const apiUrl = `${API_BASE_URL}/ocr/${exhibition}/${pavCode}`;
        const res = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${API_TOKEN}` },
        });

        let textData = [];

        if (res.data.err === 0 && Array.isArray(res.data.results)) {
          try {
            const standItem = res.data.results[0];
            if (standItem && standItem.JSON) {
              const parsedJSON = JSON.parse(standItem.JSON);
              textData = Array.isArray(parsedJSON.text_data) ? parsedJSON.text_data : [];
            }
          } catch (parseError) {
            console.error("❌ Error parsing JSON from results:", parseError);
            setError("Error parsing stand data");
            textData = [];
          }
        } else if (res.data.results) {
          textData = res.data.results;
        } else {
          console.warn("⚠️ Unexpected response format");
        }

        // Process color data from the same response
        if (res.data.results && Array.isArray(res.data.results)) {
          textData = textData.map(item => {
            const match = res.data.results.find(result =>
              result.StandCode === (item.StandCode ? item.StandCode.toString() : item.code ? item.code.toString() : "")
            );

            return {
              ...item,
              color: match ? (match.Status === 1 ? "#00FF00" : "#FF0000") : "rgba(255, 255, 255, 0.5)",
            };
          });
        }

        const mappedStands = textData.map(item => ({
          code: item.code || item.StandCode,
          x: item.box ? Math.floor((item.box[0][0] + item.box[2][0]) / 2) : 0,
          y: item.box ? Math.floor((item.box[0][1] + item.box[2][1]) / 2) : 0,
          confidence: item.confidence,
          text: item.text,
          color: item.color,
          box: item.box,
        }));

        setStands(mappedStands);
      } catch (err) {
        console.error("API Error:", err);
        if (err.response) console.error("Response status:", err.response.status);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [exhibition, pavCode]);

  return { stands, loading, error };
};

export default useFetchStands;